import { Avatar, Box, CardHeader } from '@mui/material'
import Divider from '@mui/material/Divider'

const UserCard = ({ datos = null }) => {
  return (
    <Divider>
      <CardHeader
        sx={{ position: 'relative' }}
        avatar={
          <Box>
            <Avatar
              src={`/assets/images/${datos.image}`}
              sx={{
                transition: '.3s',
                aspectRatio: '4/4',
                width: '64px',
                height: '64px',
              }}
            />
          </Box>
        }
        title={`${datos?.surname ?? ''}`}
        subheader={`${datos?.name ?? ''}`}
        titleTypographyProps={{ textAlign: 'left !important' }}
        subheaderTypographyProps={{ textAlign: 'left !important' }}
      />
    </Divider>
  )
}

export default UserCard
